import TemplateCard from '@/atoms/TemplateCard/TemplateCard';
import Avatar from 'react-avatar';
import { Link } from 'react-router-dom';
import './TemplateRow.scss';

export interface TemplateRowProps {
	title: string;
	subtitle: string;
	templateDetails: { url: string; title?: string; subtitle?: string }[];
}

const TemplateRow: React.FC<TemplateRowProps> = props => {
	return (
		<div className='template-row'>
			<div className='detailsRow'>
				<div className='header'>
					<Avatar
						src='/static/img/TemplateIcons.svg'
						round
						size='50'
					/>
					<div className='titleCol'>
						<h3 className='title'>{props.title}</h3>
						<h4 className='subtitle'>{props.subtitle} & more</h4>
					</div>
				</div>
				<div className='viewAll'>
					<Link
						to='/templates'
						style={{ textDecoration: 'none', color: 'white' }}
					>
						View All &gt;
					</Link>
				</div>
			</div>
			<div className='template-cards'>
				{props.templateDetails.map((template, index) => (
					<TemplateCard
						key={index}
						imageUrl={template.url}
						title={template.title ?? 'Title'}
					/>
				))}
			</div>
		</div>
	);
};

export default TemplateRow;
